module.exports = require("@wildboar/x500/src/lib/modules/BasicAccessControl/rule-and-simple-access-control.va");